import { useState } from "react";
// MSAL imports
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State Import
import { useUserCard } from "../../state/userCardState";
import { useWardrobeList } from "../../state/wardrobeListState";

// Components
import { WardrobeRequestFrom } from "./WardrobeRequestForm";
// MUI
import Box from "@mui/material/Box";

export function WardrobeRequest() {
  // MSAL auth request
  // Fetch User
  const [userCard, setUserCard] = useState({});
  const { isSuccess: isSuccessUser, data: dataUser } = useUserCard();

  // Success Function
  const successFuncUser = () => setUserCard(dataUser.data.data.data.data.user);
  // Error Function
  const errorFuncUser = () =>
    console.warn(`Error: ${dataUser.data.status}: ${dataUser.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(
    isSuccessUser,
    dataUser,
    dataUser?.data?.status,
    successFuncUser,
    errorFuncUser,
  );

  // Fetch Wardobes
  const [wardrobes, setWardrobes] = useState([]);
  const { isSuccess, data } = useWardrobeList({
    search: null,
    page: null,
  });
  // Success Function
  const successFunc = () => setWardrobes(data.data.data.data.list.wardrobe);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <WardrobeRequestFrom userCard={userCard} wardrobes={wardrobes} />
      </Box>
    </>
  );
}
